import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';
import AccidentOtherPersonMissingInformationForm from '../AccidentOtherPersonMissingInformationForm';
import { GridItem } from '@flos/react-ui';

const OtherPersonMissingInformation = (): React.JSX.Element => {
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { accidentOtherPerson } = missingInformation;

    if (!accidentOtherPerson?.length) return <></>;

    return (
        <>
            {accidentOtherPerson
                .filter((missingInformation) => !!missingInformation.fixedId)
                .map((missingInformation) => {
                    return (
                        <GridItem span={12} key={missingInformation.fixedId}>
                            <AccidentOtherPersonMissingInformationForm
                                accidentOtherPersonMissingInformation={missingInformation}
                            />
                        </GridItem>
                    );
                })}
        </>
    );
};

export default OtherPersonMissingInformation;
